/* DALY MOUNTAIN — Inject Judge.me star badge into product cards (v1.2) */
(function() {
  'use strict';
  var CACHE_KEY = 'dmk_card_badges_v3';
  var CACHE_TTL = 60 * 60 * 1000;

  function loadCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      var now = Date.now();
      Object.keys(parsed).forEach(function(k) {
        if (!parsed[k] || (now - parsed[k].t > CACHE_TTL)) delete parsed[k];
      });
      return parsed;
    } catch (e) { return {}; }
  }
  function saveCache(cache) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
  }
  var cache = loadCache();
  var pending = {};

  function fetchBadge(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle].html);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var badge = doc.querySelector('.jdgm-prev-badge');
        if (!badge) return null;
        badge.removeAttribute('style');
        var html2 = badge.outerHTML;
        cache[handle] = { t: Date.now(), html: html2 };
        saveCache(cache);
        delete pending[handle];
        return html2;
      })
      .catch(function() { delete pending[handle]; return null; });
    return pending[handle];
  }

  function findTitle(card) {
    // Try multiple selectors common to Horizon resource-card AND product-card
    var sel = [
      '.resource-card__title',
      'product-title',
      'product-title text-block',
      '.product-card__content product-title',
      '.product-card__content text-block',
      'h3', 'h4',
      '[class*="card-title"]',
      '[class*="product-title"]',
      'a[href*="/products/"]'
    ];
    for (var i = 0; i < sel.length; i++) {
      var el = card.querySelector(sel[i]);
      if (el) return el;
    }
    return null;
  }

  function injectInto(card, badgeHTML) {
    if (!badgeHTML) return;
    if (card.querySelector('.dmk-card-stars')) return;
    var title = findTitle(card);
    if (!title) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'dmk-card-stars';
    wrapper.innerHTML = badgeHTML;

    var badge = wrapper.querySelector('.jdgm-prev-badge');
    if (badge) {
      var n = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      if (n === 0) { return; }
    }

    wrapper.style.cssText = 'display:flex !important;visibility:visible !important;align-items:center;gap:6px;margin:6px 0 4px;line-height:1;min-height:18px;width:auto;';
    if (badge) badge.style.cssText = 'display:inline-flex !important;visibility:visible !important;align-items:center;gap:6px;line-height:1;';
    var stars = wrapper.querySelector('.jdgm-prev-badge__stars');
    if (stars) stars.style.cssText = 'display:inline-flex !important;visibility:visible !important;font-size:0.85rem;letter-spacing:0.5px;color:#c0432b;line-height:1;';
    var text = wrapper.querySelector('.jdgm-prev-badge__text');
    if (text) text.style.cssText = 'display:inline !important;visibility:visible !important;font-size:0.72rem;color:rgba(61,47,31,0.7);letter-spacing:0.02em;font-family:Inter,sans-serif;';
    wrapper.querySelectorAll('.jdgm-star').forEach(function(s) {
      s.style.cssText = 'display:inline-block !important;visibility:visible !important;color:#c0432b;';
    });

    // Smart insertion: prefer placing AFTER the closest containing block of the title
    // so it appears beneath the visible title text
    var insertTarget = title;
    // If title is the link (fallback), insert wrapper INSIDE the link's parent after the link
    var parent = insertTarget.parentNode;
    if (parent) {
      if (insertTarget.nextSibling) {
        parent.insertBefore(wrapper, insertTarget.nextSibling);
      } else {
        parent.appendChild(wrapper);
      }
    }

    // If still hidden after insert, try moving up the tree
    setTimeout(function() {
      if (wrapper.offsetHeight === 0) {
        var cardRoot = wrapper.closest('product-card, .resource-card, .product-card');
        // Try inserting at end of card root
        if (cardRoot && cardRoot !== wrapper.parentNode) {
          cardRoot.appendChild(wrapper);
        }
      }
    }, 200);
  }

  function scanCards() {
    var cards = document.querySelectorAll('product-card, .product-card, .resource-card, .product-grid__card');
    cards.forEach(function(card) {
      if (card.dataset.dmkStars === 'done') return;
      if (card.closest('.mega-menu, header-menu, header-component, header')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!match) return;
      var handle = match[1];
      card.dataset.dmkStars = 'pending';
      fetchBadge(handle).then(function(html) {
        injectInto(card, html);
        card.dataset.dmkStars = 'done';
      });
    });
  }

  function init() {
    scanCards();
    setTimeout(scanCards, 1500);
    setTimeout(scanCards, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
